const AppName = process.env.VUE_APP_NAME;
const AppUrl = process.env.VUE_APP_CORE;

const BHAPI = process.env.VUE_APP_BH_API;
const BHSCOPE = process.env.VUE_APP_BH_API_SCOPE;

const AppClientID = process.env.VUE_APP_CLIENT_ID;
const AppLoginAuthority = process.env.VUE_APP_AUTHORITY;
const AppLoginFlow = process.env.VUE_APP_LOGIN_FLOW;
const AppSignUpFlow = process.env.VUE_APP_SIGNUP_FLOW;
const currentApp = "bh";
const BHPOnsiteUIUrl = process.env.VUE_APP_BHP_Onsite_UI;


const AppScope = ["openid", "profile", `${AppClientID}`]

export const BaseConfig = {
  AppName,
  AppUrl,
  BHAPI,
  BHSCOPE,
  AppClientID,
  AppLoginAuthority,
  AppLoginFlow,
  AppSignUpFlow,
  currentApp,
  AppScope,
  BHPOnsiteUIUrl
};
